import React from "react";
import isEmpty from "lodash/isEmpty";
import GTExHeatmap from "../../../../components/gtex/GTExHeatmap";
import RPKMExpressions from "../RPKMExpressions";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import { TISSUES, heatmapConfig } from "./constants";

export const showInfo = (item) => {
  let gtexGeneModel;
  let gencodeGene;
  let gtexGeneModelStart;
  let result = null;

  if (
    !isEmpty(item.gene_model_positions) &&
    item.gene_model_positions !== null
  ) {
    gtexGeneModelStart = item.gene_model_positions.start;
    gtexGeneModel = (
      <div>
        <b> Gene model from GTEx: </b>
        {item.gene_model_positions.chromosome}
        {", locations "}
        {item.gene_model_positions.start}
        {" - "}
        {item.gene_model_positions.end}
        {", "}
        {item.gene_model_positions.strand === "+"
          ? " possitive strand"
          : " negative strand"}
      </div>
    );
  }

  if (
    !isEmpty(item.gene_positions) &&
    item.gene_positions !== null &&
    gtexGeneModelStart !== item.gene_positions.start
  ) {
    gencodeGene = (
      <div>
        <b> Gene from GENCODE: </b>
        {item.gene_positions.chromosome}
        {", locations "}
        {item.gene_positions.start}
        {" - "}
        {item.gene_positions.end}
        {", "}
        {item.gene_positions.starnd && item.gene_positions.strand === "+"
          ? " possitive strand"
          : " negative strand"}
      </div>
    );
  }

  result = (
    <div className="tw-mb-4">
      {gtexGeneModel}
      {gencodeGene}
    </div>
  );

  return result;
};

export const getGTExTPMData = (expressions) => {
  const gtexTPMData = [];
  Object.keys(TISSUES).forEach((k) => {
    const cell = {
      expression: TISSUES[k].name,
      value:
        expressions && expressions.hasOwnProperty(k)
          ? expressions[k].toFixed(2)
          : 0,
    };
    gtexTPMData.push(cell);
    gtexTPMData.sort((a, b) => {
      return b.value - a.value;
    });
  });
  return gtexTPMData;
};

export const getGTExTPM = (
  itemExpressions,
  key,
  gencodeId,
  geneName,
  GTExUrl
) => {
  let expressions = null;
  const TPMData = getGTExTPMData(itemExpressions);
  if (Array.isArray(TPMData) && TPMData.length > 0) {
    expressions = (
      <div>
        <div>
          <b>
            {"Gene expression for "}
            {geneName}
          </b>
          <small>
            {" (view "}
            <a href={getVarsoUrl(GTExUrl)} target="_blank">
              {" "}
              {gencodeId}
            </a>
            {"   on GTEx web site)"}
          </small>
        </div>
        <RPKMExpressions
          data={TPMData}
          uniqueKey={`gene-${key}`}
          yAxisTitle="Median TPM"
        />
      </div>
    );
  }
  return expressions;
};

export const getHeatmapData = (values) => {
  const gtexHeatmapData = [];
  const exons = [];
  if (values && values.length > 0) {
    for (let i = 0; i < values.length; i++) {
      const exonIndex = values[i].exon_number;
      const colName = `exon ${exonIndex}`;
      const { expressions } = values[i];
      exons.push(colName);
      if (!isEmpty(expressions)) {
        Object.keys(TISSUES).forEach((k) => {
          const cell = {
            x: colName,
            y: TISSUES[k].name,
            value:
              expressions && expressions.hasOwnProperty(k) ? expressions[k] : 0,
            exon: exonIndex,
          };
          gtexHeatmapData.push(cell);
        });
      }
    }
  }

  return {
    gtexHeatmapData,
    exons,
  };
};

export const getHeatmap = (itemExons, key, gencodeId, geneName, GTExUrl) => {
  let heatmap = null;
  const gtexHeatmapDataResult = getHeatmapData(itemExons);
  const { gtexHeatmapData, exons } = gtexHeatmapDataResult;
  if (!isEmpty(gtexHeatmapData)) {
    heatmap = (
      <div>
        <div>
          <b>
            {"Exon expression for "}
            {geneName}
          </b>
          <small>
            {" (view "}
            <a href={getVarsoUrl(GTExUrl)} target="_blank">
              {" "}
              {gencodeId}
            </a>
            {" on GTEx web site)"}
          </small>
        </div>
        <GTExHeatmap
          uniqueKey={key}
          heatmapConfig={heatmapConfig}
          heatmapData={gtexHeatmapData}
        />
      </div>
    );
  } else {
    heatmap = (
      <div>
        {"All tissues in "}
        {exons.map((exon, i) => {
          return (
            <span key={i}>
              {exon}
              {i < exons.length - 1 ? ", " : ""}
            </span>
          );
        })}
        {"  have 0 median read count per base."}
      </div>
    );
  }
  return heatmap;
};
